import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import unsubscribedImage from "@/assets/agent/unsubscribed.webp";

export const UnsubscribedImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[unsubscribedImage]}
      {...props}
    />
  );
};

UnsubscribedImage.displayName = 'UnsubscribedImage';
